import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

// Cambia la clave si usas otro nombre en localStorage
const TABLET_MODE_FEATURE_KEY = 'tabletModeEnabled';

export const TabletModeRedirectGuard: CanActivateFn = (route, state) => {
  // No redirigir si ya estamos en tablet/sign-in o tablet/clock
  if (state.url.startsWith('/tablet')) {
    return true;
  }

  const isTabletMode = localStorage.getItem(TABLET_MODE_FEATURE_KEY) === 'true';
  if (isTabletMode) {
    return inject(Router).parseUrl('/tablet/sign-in');
  }
  return true;
};
